import {Component, Input, OnInit} from '@angular/core';
import {IObject, ISpot} from '../../shared/models/models';
import {EventService} from '../../shared/services/event.service';
import {ActivatedRoute} from '@angular/router';
import {environment} from '../../../environments/environment';
import {ServerService} from '../../shared/services/server.service';

@Component({
  selector: 'app-object',
  templateUrl: './object.component.html',
  styleUrls: ['./object.component.scss']
})
export class ObjectComponent implements OnInit {
  @Input() gallery: boolean = true;
  @Input() editMode: boolean = false;
  @Input() object: IObject;
  @Input() user;
  galleryModal: boolean = false;
  isNew: boolean = false;
  api = environment.apiUrl;
  newObject: boolean = false;
  galleryOpenable: boolean = false;
  mapModal: boolean = false;
  total_first = 0;
  total_second = 0;
  fact: number;
  plan: number;
  financePercent: number = 0;

  realizationPer: number;
  spots: ISpot[] = [];

  countOfNull = 0;
  realDis: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private eventService: EventService,
    private serverService: ServerService
  ) {
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      if (params.id) {
        this.isNew = true;
        this.newObject = false;
        // this.object.id = params.id;
        this.galleryOpenable = true;
      }
      if (params.id == 0) {
        this.newObject = true;
      }
    });

    this.eventService.changeObjectNameEvent.subscribe((name) => {
      if (this.object) {
        this.object.name = name;
      }
    });

    this.eventService.updateMainThumbnail.subscribe((res) => {
      this.object.src = this.getObjectStyles(res);
    });

    this.object.src = this.getObjectStyles(this.object.photo_id);

    this.financePercent = this.object.finances;

    if (this.object.total_flat_count !== 0) {
      this.realizationPer = this.object.sales_flat_count / this.object.total_flat_count * 100;
    } else {
      this.realizationPer = 0;
    }
    this.eventService.countObject.subscribe(r => {
      this.object.counter = r;
    });
  }


  getObjectStyles(id: number): string {
    if (id) {
      return this.api + 'BuildingFiles/DownloadFile?fileID=' + id + '&isThumb=' + true;
    }
    return '';
  }

  getCompletePercent(number) {
    if (typeof number === 'undefined' || +number === 0) {
      return 0;
    }
    return Math.round(number);
  }

  closeGallery(event) {
    this.eventService.closeGallery.emit(true);
    this.galleryModal = false;
  }

  calculate(v1: number, v2: number) {
    let t1 = 0;
    let t2 = 0;
    if (v1) {
      t1 = parseInt(v1.toString());
    }
    if (v2) {
      t2 = parseInt(v2.toString());
    }
    return t1 + t2;
  }

  calculateEconomy() {
    let fact = 0;
    let plan = 0;

    if (this.object.investments.own_investments2 + this.object.investments.bd_investments2 != 0) {
      fact = this.calculate(this.object.investments.own_investments2, this.object.investments.bd_investments2);
    }

    if (this.object.investments.own_investments + this.object.investments.bd_investments != 0) {
      plan = this.calculate(this.object.investments.own_investments, this.object.investments.bd_investments);
    }

    if (plan != 0 && fact != 0) {
      return plan - fact;
    } else {
      return null;
    }
  }
}
